/* eslint-disable @typescript-eslint/no-explicit-any */

export const ReactTableCell = ({ header, value }: any) => {
  switch (header) {
    case "expression": {
      return <span className="flex items-center gap-1 flex-wrap">{value}</span>;
    }
    case "Result": {
      return <span className="flex items-center gap-1 flex-wrap">{value}</span>;
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
